<form id="informations-client-form" class="px-4" [formGroup]="maisonForm">
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>

    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.constructionYear"
        id="constructionYear"
        name="constructionYear"
        label="Année de construction"
        [maxLengthNumber]="4"
        (input)="onConstructionYearChanged($event)"
        type="number"
        errorMessage="L'année de construction doit être un nombre à 4 chiffres."
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.livingAreaM2"
        id="livingAreaM2"
        name="livingAreaM2"
        label="Surface habitable"
        placeholder="Ex : 100"
        fixedText="m²"
        type="number"
        (input)="onLivingAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.livingRoomAreaM2"
        id="livingRoomAreaM2"
        name="livingRoomAreaM2"
        label="Surface séjour"
        placeholder="Ex : 30"
        fixedText="m²"
        type="number"
        (input)="onLivingRoomAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-select
        id="exposure"
        [items]="exposureSelectItems"
        [selectedItem]="exposureItem"
        label="Exposition"
        (selected)="onExposureSelected($event)"
      ></p-select>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-select
        id="numberOfRooms"
        [items]="numberSelectItems"
        [selectedItem]="numberOfRoomsItem"
        label="Nb de pièces"
        (selected)="onNumberOfRoomsSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-select
        id="numberOfBedrooms"
        [items]="numberSelectItems"
        [selectedItem]="numberOfBedroomsItem"
        label="Nb de chambres"
        (selected)="onNumberOfBedroomsSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.landAreaM2"
        id="landAreaM2"
        name="landAreaM2"
        label="Surface terrain"
        placeholder="Ex : 1000"
        fixedText="m²"
        (input)="onLandAreaM2Changed($event)"
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-select
        id="numberOfBathrooms"
        [items]="numberSelectItems"
        [selectedItem]="numberOfBathroomsItem"
        label="Nb de salles de bain"
        (selected)="onNumberOfBathroomsSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="maisonForm.controls.heating"
        id="heating"
        name="heating"
        label="Chauffage"
        placeholder="Ex : Pellet"
        (input)="onHeatingChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-select
        id="ghgEmissions"
        [items]="alphabiticalCategoriesItems"
        [selectedItem]="ghgEmissionsItem"
        label="GES"
        (selected)="onGhgEmissionsSelected($event)"
      ></p-select>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-select
        id="energyPerformance"
        [items]="alphabiticalCategoriesItems"
        [selectedItem]="energyPerformanceItem"
        label="DPE"
        (selected)="onEnergyPerformanceSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-select
        id="levelItem"
        [items]="numberSelectItems"
        [selectedItem]="levelItem"
        label="Niveau"
        (selected)="onLevelSelected($event)"
      ></p-select>
    </div>
  </div>
</form>
